// extracted by mini-css-extract-plugin
export var downArrow = "_7f-0";
export var label = "_7f-1";
export var treatmentCard = "_7f-3";
export var upArrow = "_7f-2";